import { ConditionApi } from 'cadenza/api-client/conditions/condition-api';

import { ajax } from '../api';

export class MapBasedConditionApi extends ConditionApi {

  registerConditionMap () {
    return ajax('/maps', {
      type: 'POST',
      data: this.conditionQueryParams
    });
  }

  unregisterConditionMap (mapId) {
    return ajax(`/maps/${mapId}`, {
      type: 'DELETE'
    });
  }

}
